export interface Language {
  value: string;
  countryCode: string;
  label: string;
}

export const LANGUAGE_CHANGED_CHANNEL = 'language:changed';

export const LANGUAGES: Language[] = [
  { value: 'en', countryCode: 'us', label: 'English' },
  { value: 'de', countryCode: 'de', label: 'Deutsch' },
];
